export const BtnVariant = {
  Primary: 'primary',
  Secondary: 'secondary',
  Outline: 'outline'
}
